/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from "react";
import { getRoles } from "lib/services/roles";
import { Autocomplete } from "@material-ui/lab";
import { TextField, CircularProgress } from "@material-ui/core";

export default function RolesAutocomplete({
  selectedRoles = [],
  inputProps = {},
  onChange
}) {
  const [roles, setRoles] = React.useState([]);
  const [fetched, setFetched] = React.useState();
  const [open, setOpen] = React.useState(false);
  const loading = open && !fetched && !roles.length;

  const fetchAndSetRoles = async () => {
    const result = await getRoles();
    setRoles(result.data);
    setFetched(true);
  };

  React.useEffect(() => {
    if (loading) fetchAndSetRoles();
  }, [loading]);

  const handleChange = (_e, value) => {
    if (onChange) onChange(value);
  };

  return (
    <Autocomplete
      multiple
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      loading={loading}
      id="tags-outlined"
      options={roles}
      getOptionLabel={option => option.name}
      getOptionSelected={(option, value) => option.name === value.name}
      defaultValue={selectedRoles}
      filterSelectedOptions
      onChange={handleChange}
      renderInput={params => {
        const props = { ...params, ...inputProps };
        return (
          <TextField
            {...props}
            placeholder="Roles"
            InputProps={{
              ...params.InputProps,
              ...inputProps.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              )
            }}
          />
        );
      }}
    />
  );
}
